import React, { useState, useEffect , useContext} from "react";
import moment from "moment";
import { Card, Modal, Row, Col, Alert,Table,Button,ButtonGroup } from "react-bootstrap";
import axios from "axios";
import Utils from "../../common/Utils";
import _ from "lodash";
import { UserContext } from "../../common";

const LeaveCalendar = (props) => {
  const { userData } = useContext(UserContext);

  const [filter, setFilter] = useState({
    dtCnt:moment(props.fromDt),
    mode: 3,
  }); //1: daily, 2: weekly, 3: monthly

  const [data, setData] = useState({
    loading: false,
    data: [],
    start: 0,
    error: "",
  });

  const [selBranch, setSelBranch] = useState("");

  const fetchList = () => {
    setData({ ...data, loading: true, start: 0, error: "" });
    axios
      .get(
        Utils.apiUrl("leaves/leavecalendar") + `?fromDt=${getStartDate()}&toDt=${getEndDate()}`,
        Utils.apiHeaders()
      )
      .then((res) => {
        if (res.data.success) {
          setData({ ...data, loading: false,start: 0, data: res.data.data, error: '' });
        } else {
          setData({ ...data, loading: false,start: 0,data:[], error: res.data.message });
        }
      })
      .catch((err) => {
        setData({ ...data, loading: false,start: 0,data:[], error: err.message });
      });
  };

  useEffect(fetchList, [filter]);

  const setDate = (dir) => (e) => {
    setFilter({...filter,dtCnt:getDate(dir)});
  };

  const getDate = (dir) => {
    const dt = moment(filter.dtCnt);
    if (filter.mode === 1) {
      dt.add("day", dir);
    } else if (filter.mode === 2) {
      dt.add("day", 7 * dir);
    } else if (filter.mode === 3) {
      dt.add("month", dir);
    }

    return dt;
  };

  const getStartDate = () => {
    if (filter.mode === 1) {
      return filter.dtCnt.format("YYYY-MM-DD");
    } else if (filter.mode === 2) {
      return moment(filter.dtCnt).day(1).format("YYYY-MM-DD");
    } else if (filter.mode === 3) {
      return filter.dtCnt.startOf("month").format("YYYY-MM-DD");
    }
  };

  const getEndDate = () => {
    if (filter.mode === 1) {
      return filter.dtCnt.format("YYYY-MM-DD");
    } else if (filter.mode === 2) {
      return moment(filter.dtCnt).day(7).format("YYYY-MM-DD");
    } else if (filter.mode === 3) {
      return filter.dtCnt.endOf("month").format("YYYY-MM-DD");
    }
  };

  const gotoDate = (wdate) => (e) => {
    setFilter({ ...filter, mode: 1,dtCnt:wdate });
  };

  const getDateRange = () => {
    if (filter.mode === 1) {
      return filter.dtCnt.format("MMM DD, YYYY");
    } else if (filter.mode === 2) {
      return moment(filter.dtCnt).day(1).format("MMM DD, YYYY") + " - " + moment(filter.dtCnt).day(7).format("MMM DD, YYYY");
    } else if (filter.mode === 3) {
      return filter.dtCnt.format("MMM - YYYY");
    }
  };

  const holidaysForDate = (dt) => {
    let alltasks = { paid: [], unpaid: []};
    let tmp = data.data.filter((d) => moment(dt).isSameOrAfter(moment(d.leave_from)) && moment(dt).isSameOrBefore(moment(d.leave_to)));
    tmp = tmp.filter((d) => selBranch==="" || _.trim(d.branch)==selBranch);
    if (tmp.length > 0) {
      alltasks["paid"] = tmp.filter((t) => parseInt(t.paid) === 1);
      alltasks["unpaid"] = tmp.filter((t) => parseInt(t.paid) === 0);
    }
    return alltasks;
  };

  const perpage = () => {
    return Utils.perpage;
  };

  const dailyView = () => (
    <>
      <Table bordered hover responsive className="mt-4 text-nowrap">
        <thead>
          <tr className="align-middle">
            <th style={{ width: "50px" }}>Sr. No.</th>
            <th>Name</th>
            <th className="text-center" style={{ width: "200px" }}>Holiday</th>
            <th className="text-center" style={{ width: "100px" }}>Type</th>
          </tr>
        </thead>
        <tbody>
          {((_.get(userData, "is_super_user", false) ? _.filter(data.data, d => selBranch==="" || _.trim(d.branch)==selBranch) : data.data).slice(data.start, data.start + perpage())).map((d, idx) => {
           
            let label = (parseInt(d.paid) ? "success" : "warning");

            return (
              <tr key={d.id} className="align-middle">
                <td>
                  <div className={`tb-lable tb-lable-${label} text-center`}>{Utils.addZero(idx + 1 + data.start)}</div>
                </td>
                <td className="text-start">{d.name}</td>
                <td className="text-center">{moment(d.leave_from).format("DD-MMM-YY")} to {moment(d.leave_to).format("DD-MMM-YY")}</td>
                <td className="text-center">{parseInt(d.full) ? 'Full' : 'Partial'}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
      {data.data.length > perpage() && showPagination()}
    </>
  );

  const showPagination = () => {
    return (
      <div className="d-flex flex-row-reverse">
        {data.start >= data.data.length-perpage() && (
          <div className="text-disabled ms-2">
            <img src={`${process.env.PUBLIC_URL}/images/arrow-right-d.png`} alt="Next" /> Next
          </div>
        )}
        {data.start < data.data.length-perpage() && (
          <div className="clickable ms-2 text-clickable" onClick={() => setData({...data,start: data.start + perpage()})}>
            <img src={`${process.env.PUBLIC_URL}/images/arrow-right.png`} alt="Next" /> Next
          </div>
        )}
        {data.start >= perpage() && (
          <div className="clickable text-clickable" onClick={() => setData({...data,start: data.start - perpage()})}>
            Previous <img src={`${process.env.PUBLIC_URL}/images/arrow-left.png`} alt="Previous" />
          </div>
        )}
        {data.start === 0 && (
          <div className="text-disabled">
            Previous <img src={`${process.env.PUBLIC_URL}/images/arrow-left-d.png`} alt="Previous" />
          </div>
        )}
      </div>
    );
  };

  const weeklyView = () => {
    let currecs = [];
    let wkdt = getStartDate();
    let wkdaydt = null;
    return (
      <Table responsive className="h-100" style={{ minHeight: "400px" }}>
        <tr>
          {_.fill(new Array(7), 0).map((v, k) => {
            wkdaydt = moment(wkdt).add(k, "day");
            currecs = holidaysForDate(wkdaydt);

            return (
              <td key={k} className="align-top h-100 d-block d-md-table-cell weeklybox">
                <div className="d-flex flex-column h-100 weekcolumn p-0 clickable" title="Click to view daily" onClick={gotoDate(wkdaydt)}>
                  <div className="weekdate">
                    {wkdaydt.format("DD")} <span className="weekday d-inline d-md-none">{wkdaydt.format("dddd")}</span>
                  </div>
                  <div className="weekday d-none d-md-block">{wkdaydt.format("dddd")}</div>
                  <Card className="m-0 p-0 flex-grow-1 h-100 border-0">
                    {["paid", "uppaid"].map((cat) => (
                      <div className={`weekcol weekcol-${cat} my-1`}>
                        {_.slice(currecs[cat], 0, 3).map(
                          (t, tidx) => tidx < 3 && <div className="py-1 ms-1">{_.truncate(t.name, { length: 30 })}</div>
                        )}
                      </div>
                    ))}
                  </Card>
                </div>
              </td>
            );
          })}
        </tr>
      </Table>
    );
  };


  const drawDateBox = (dt, sameMonth = true) => {
    if (_.isNull(dt)) {
      return <Card className="m-0 p-0 monthbox holiday monthbox-empty mr-1 my-1"></Card>;
    }

    let currecs = holidaysForDate(dt);

    if (_.flatten(_.values(currecs)).length === 0) {
      return (
        <Card className={`m-0 p-0 monthbox holiday mr-1 my-1 bg-${sameMonth ? "white" : "grey"}`}>
          <Card.Header className={`d-block d-md-none text-${sameMonth ? "info bg-white border-info" : "secondary"}`}>
            <span className="monthdate">{moment(dt).format("DD")}</span>
            <span className="monthday">{moment(dt).format("dddd")}</span>
          </Card.Header>
          <div className="d-flex flex-column h-100">
            <div className="vh-100"></div>
            <div className="flex-growth-1 text-end pe-2 text-info d-none d-md-block">
              <b>{moment(dt).format("DD")}</b>
            </div>
          </div>
        </Card>
      );
    }

    return (
      <Card className="m-0 p-0 monthbox holiday mr-1 my-1 clickable" title="Click to Daily View" onClick={gotoDate(moment(dt))}>
        <Card.Header className={`d-block d-md-none bg-${sameMonth ? "white" : "grey"} text-info border-info`}>
          <span className="monthdate">{moment(dt).format("DD")}</span>
          <span className="monthday">{moment(dt).format("dddd")}</span>
        </Card.Header>

        <div className="d-flex flex-column h-100">
          <div className="vh-100">
            {["paid", "unpaid"].map((cat) => (
              <div className={`weekcol weekcol-${cat} my-1`}>
                {_.slice(currecs[cat], 0, 1).map((r) => (
                  <div className="ms-1 d-flex flex-row">
                    <div className="text-start p-0">{_.truncate(r.name, { length: 30 })}</div>
                    {currecs[cat].length > 1 && <div className={`month-count ${cat} ms-auto`}>+{currecs[cat].length - 1}</div>}
                  </div>
                ))}
              </div>
            ))}
          </div>

          <div className="flex-growth-1 text-end pe-2 text-info d-none d-md-block">
            <b>{moment(dt).format("DD")}</b>
          </div>
        </div>
      </Card>
    );
  };

  const monthlyView = () => {
    let mdt = getStartDate();

    return (
      <>
        <Row className="d-md-none mt-2">
          {Utils.getMonthDates(mdt).map((v1) => (
            <Col xs={6} className="p-0 px-1" key={v1}>
              {drawDateBox(v1, moment(mdt).month() === moment(v1).month())}
            </Col>
          ))}
        </Row>

        <Table responsive className="h-100 d-none d-md-table" style={{ minHeight: "300px" }}>
          <tr>
            {Utils.weekdays().map((v, k) => {
              return (
                <td key={k} className="align-top h-100" style={{ width: 100 / 7 + "%" }}>
                  <div className="d-flex flex-column h-100 p-0">
                    <div className="monthweek">{v.substring(0, 3).toUpperCase()}</div>
                    {Utils.getAllWeekDates(mdt, k + 1).map((v1) => drawDateBox(v1))}
                  </div>
                </td>
              );
            })}
          </tr>
        </Table>
      </>
    );
  };

  return (
    <Modal size="xl" show={true} onHide={props.onHide}>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          
          <div className="d-flex">
            <div>Holiday Calendar</div>
            {(_.get(userData, "is_super_user", false)  && <select className="form-select w-auto mx-2" onChange={(e) => setSelBranch(e.currentTarget.value)}>
                  <option value="">All Branches</option>
                  {_.uniq(_.map(data.data, d => d.branch)).map(b => <option key={b} selected={b===selBranch} value={b.name}>{b}</option>)}
            </select>)}
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        
        <Row className="mb-4">
          <Col className="d-flex justify-content-between">
            <ButtonGroup aria-label="Basic example" className="shadow btn-group order-3 order-lg-1 d-none d-sm-block">
              <Button variant="light" className="radius-left" onClick={setDate(-1)}>
                <img src={`${process.env.PUBLIC_URL}/images/arrow-left.png`} alt="Previous" />
              </Button>
              <Button variant="primary"> {getDateRange()} </Button>
              <Button variant="light" className="radius-right" onClick={setDate(1)}>
                <img src={`${process.env.PUBLIC_URL}/images/arrow-right.png`} alt="Next" />
              </Button>
            </ButtonGroup>
            
            <ButtonGroup aria-label="Basic example" className="d-none d-sm-inline shadow btn-group order-1 order-lg-3 flex-xs-fill">
              <Button
                variant={`${filter.mode === 1 ? "primary" : "light"}`}
                className="radius-left"
                onClick={(e) => {
                  setFilter({...filter,dtCnt:moment(),mode: 1});
                }}
              >
                Daily
              </Button>
              <Button
                variant={`${filter.mode === 2 ? "primary" : "light"}`}
                className=""
                onClick={(e) => {
                  setFilter({ ...filter, mode: 2 });
                }}
              >
                Weekly
              </Button>
              <Button
                variant={`${filter.mode === 3 ? "primary" : "light"}`}
                className="radius-right"
                onClick={(e) => {
                  setFilter({ ...filter, mode: 3 });
                }}
              >
                Monthly
              </Button>
            </ButtonGroup>
          </Col>
        </Row>



        {data.loading && <Alert variant="warning">fetching holidays..</Alert>}
        {!data.loading && data.error != "" && <Alert variant="danger">{data.error}</Alert>}
        {!data.loading && data.data.length > 0 && (
            <>
              {filter.mode === 1 && dailyView()}
              {filter.mode === 2 && weeklyView()}
              {filter.mode === 3 && monthlyView()}
            </>
          )}
            
      </Modal.Body>
    </Modal>
  );
};

export default LeaveCalendar;
